import app from './app'
import auth from './auth'
import billing from './billing'
import common from './common'
import customer from './customer'
import customers, { customerPreview } from './customers'
import dashboard from './dashboard'
import errors from './errors'
import home from './home'
import language from './language'
import navigation from './navigation'
import products from './products'
import settings from './settings'
import theme from './theme'
import timezones from './timezones'
import team from './team'
import dev from './dev'
import checkout from './checkout'

const translation = {
  common,
  navigation,
  home,
  app,
  dashboard,
  auth,
  products,
  customers,
  customerPreview,
  billing,
  settings,
  theme,
  language,
  errors,
  timezones,
  customer,
  team,
  dev,
  checkout,
} as const

export default translation
